let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3FT39")).then(() => parcelRequire('4Yleb'));